import { db } from '@/main'

export default {
  namespaced: true,
  state: {
    deliveryAgents: [],
    loading: false,
    error: null
  },
  mutations: {
    deliveryAgents(state, payload) {
      state.deliveryAgents = payload || []
    },
    error(state, payload) {
      state.error = payload
    },
    startAction(state) {
      state.error = null
      state.loading = true
    },
    stopAction(state) {
      state.loading = false
    }
  },
  actions: {
    /**
     * @func
     * @desc query all delivery agents of a tenant
     *   by using onSnapshot listener
     *   this function will also be invoked automatically if there is any changes at remote
     *   so you don't have to update any client side store
     * @param [context]
     */
    subscribeDeliveryAgents(context) {
      db.collection('tenants')
        .doc(context.rootState.account.tenantId)
        .collection('deliveryAgents')
        .onSnapshot((querySnapshot) => {
          const deliveryAgents = []
          querySnapshot.forEach((snapshot) => {
            const data = snapshot.data()
            data.documentId = snapshot.id
            deliveryAgents.push(data)
          })
          console.log('Delivery agents coming', deliveryAgents)
          context.commit('deliveryAgents', deliveryAgents)
        })
    },
    createDeliveryAgents(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startAction')
        const data = {
          name: payload.name,
          phone: payload.phone
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('deliveryAgents')
          .add(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    }
  }
}
